__turbopack_context__.v({
  "root": "InlineFilters-SectionButton-module-scss-module__x9OBJW__root",
});
